window.Push = {
    isDisabledToast: false,
    settings: {
        "closeButton"       : true,
        "debug"             : false,
        "newestOnTop"       : true,
        "progressBar"       : false,
        "positionClass"     : "toast-top-right",
        "preventDuplicates" : false,
        "onclick"           : null,
        "showEasing"        : "swing",
        "hideEasing"        : "linear",
        "showMethod"        : "fadeIn",
        "hideMethod"        : "fadeOut",
        "showDuration"      : "1000",
        "hideDuration"      : "500",
        "timeOut"           : "3500"
    },
    
    translations: {
        title: Loc.g("Message système")
    },

    /**
     * Add push message
     * @param string type
     * @param string message
     * @param string title
     */
    add: function(type, message, title, options)
    {
        var addOptions      = { "iconClass" : "toast sellsy-"+type };
        var mergeOptions    = Object.assign(this.settings, addOptions);

        if (options != undefined)
            mergeOptions = Object.assign(mergeOptions, options);
        
        if (undefined == title)
            title = this.translations.title;

        if (!this.isDisabledToast) toastr[type](message, title, mergeOptions);
    },

    permanentSuccess: function(message, title, options, closeCallback) {
        mergeOptions = Object.assign(options, {
            "closeButton": true,
            "debug": false,
            "newestOnTop": true,
            "progressBar": false,
            "positionClass": "toast-top-right",
            "preventDuplicates": false,
            "onclick": closeCallback,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "0",
            "extendedTimeOut": "0",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        });
        this.add('success', message, title, mergeOptions);
    },

    /**
     * Success message
     */
    success: function(message, title, options) {
        this.add('success', message, title, options);
    },

    /**
     * Info message
     */
    info: function(message, title, options) {
        this.add('info', message,title,  options);
    },

    /**
     * Warning message
     */
    warning: function(message, title, options) {
        this.add('warning', message, title, options);
    },

    /**
     * Error message
     */
    error: function(message, title, options) {
        this.add('error', message, title, options);
    }
};

